import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";

interface Partner {
  id: string;
  company_name: string;
  logo_url: string;
  website_url?: string;
}

const PartnersSection = () => {
  const { t } = useTranslation();
  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    const fetchPartners = async () => {
      const { data } = await supabase
        .from('partners')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (data) setPartners(data as Partner[]);
    };

    fetchPartners();
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t("partners.title")}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">{t("partners.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {partners.map((partner) =>
            partner.website_url ? (
              <a
                href={partner.website_url}
                key={partner.id}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
              >
                <img
                  src={partner.logo_url}
                  alt={partner.company_name}
                  className="max-h-16 max-w-full object-contain"
                  loading="lazy"
                  width="112"
                  height="64"
                />
              </a>
            ) : (
              <div
                key={partner.id}
                className="flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
              >
                <img
                  src={partner.logo_url}
                  alt={partner.company_name}
                  className="max-h-16 max-w-full object-contain"
                  loading="lazy"
                  width="112"
                  height="64"
                />
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
